export function normalizeRuntimeSaveOutcome(result, inputConfig) {
  const isEnvelope = result && (
    Object.prototype.hasOwnProperty.call(result, 'config')
    || Object.prototype.hasOwnProperty.call(result, 'success')
    || Array.isArray(result.errors)
    || Array.isArray(result.warnings)
    || Array.isArray(result.actions)
  );

  if (!isEnvelope) {
    return {
      success: true,
      config: result || inputConfig,
      errors: [],
      warnings: [],
      actions: [],
    };
  }

  return {
    success: result.success !== false,
    config: result.config || (result.success === false ? null : inputConfig),
    errors: result.errors || [],
    warnings: result.warnings || [],
    actions: result.actions || [],
    ...(result.currentConfig ? { currentConfig: result.currentConfig, code: result.code } : {}),
  };
}

function describeRuntimeSaveError(result, fallbackMessage) {
  const first = Array.isArray(result?.errors) ? result.errors[0] : null;
  return first?.message
    || first?.error
    || result?.error?.message
    || result?.error
    || result?.message
    || fallbackMessage;
}

/**
 * Runtime mutations fail closed. Some legacy HTTP endpoints return 200 with a
 * `{ success: false }` envelope, so transport success alone is not sufficient.
 */
export function assertRuntimeSaveSucceeded(result, fallbackMessage = 'Settings were not saved.') {
  const outcome = normalizeRuntimeSaveOutcome(result, null);
  if (!outcome.success || outcome.errors.length > 0) {
    throw new Error(describeRuntimeSaveError(result, fallbackMessage));
  }
  return result;
}

export default normalizeRuntimeSaveOutcome;
